import { render, staticRenderFns } from "./WebBodyFatScalesLog.vue?vue&type=template&id=681aa033&scoped=true&"
import script from "./WebBodyFatScalesLog.vue?vue&type=script&lang=js&"
export * from "./WebBodyFatScalesLog.vue?vue&type=script&lang=js&"
import style0 from "./WebBodyFatScalesLog.vue?vue&type=style&index=0&id=681aa033&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681aa033",
  null
  
)

export default component.exports